let attributes = {
    sentence: false,
    author: false
};

let langOptions = {
    text: "",
    label: "",
    attributes: JSON.parse(JSON.stringify(attributes)),
};

let object = {
    pl: JSON.parse(JSON.stringify(langOptions)),
    de: JSON.parse(JSON.stringify(langOptions)),
    en: JSON.parse(JSON.stringify(langOptions)),
    fr: JSON.parse(JSON.stringify(langOptions)),
    it: JSON.parse(JSON.stringify(langOptions)),
    es: JSON.parse(JSON.stringify(langOptions)),
    us: JSON.parse(JSON.stringify(langOptions)),
};

export default class TextJSON{
    static getObjectCopy(){
        return JSON.parse(JSON.stringify(object));
    }

    static getLangOptionsObjectCopy(){
        return JSON.parse(JSON.stringify(langOptions));
    }
}